<template>
  <div class="d-flex justify-content-center align-items-center error-container">
    <div class="text-center">
      <textarea v-model="gtmObj" placeholder="Enter Gtm Object Here"></textarea>
      <button type="button" v-on:click="onSubmit()" class="btn-confirm active">Submit</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GTM Test",
  data() {
    return {
      gtmObj: ""
    };
  },
  methods: {
    onSubmit: function() {
      let data = JSON.parse(this.gtmObj);
      this.$gtm.trackEvent(data);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/gtmTest.vue